<template>
    <div id="sidebar" :class="sidebarActive ? 'toggle-active' : ''">
        <li class="flexy sidebar-brand">
            <div style="margin: 20px auto;">
                <router-link to="/" class="special">
                    <img src="../assets/images/android-chrome-512x512.png" class="img-circle sidebar-brand-logo" />
                </router-link>
                <div style="margin-top: 10px; padding: 0">
                    <a href="http://facebook.com/sadakhata" target="_blank" class="special"><i class="fa fa-facebook"></i> / <b>sadakhata</b></a>
                </div>
            </div>
        </li>

        <li>
            <router-link to="/" exact>
                <b>
                    Home
                </b>
            </router-link>
        </li>
        <hr />
        <li>
            <router-link to="/basic" exact>
                <b>
                    Sadakhata Basic
                </b>
            </router-link>
        </li>
        <li>
            <router-link to="/dhusor" exact>
                <b>
                    Dhusor Sadakhata
                </b>
            </router-link>
        </li>
        <li>
            <router-link to="/shobdopata" exact>
                <b>
                    Shobdopata
                </b>
            </router-link>
        </li>
        <li>
            <router-link to="/shuvro" exact>
                <b>
                    Shuvro Sadakhata
                </b>
            </router-link>
        </li>

        <hr/>
        <li>
            <a href="http://facebook.com/sadakhata" target="_blank"><b>Facebook Page</b></a>
        </li>
        <li>
            <a href="http://m.me/sadakhata.chat" target="_blank"><b>Sadakhata Chat bot</b></a>
        </li>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'Sidebar',
    computed: {
        ...mapState({
            sidebarActive: state => state.sidebar.active
        })
    }
};
</script>
